import type { Feature } from 'geojson';

import { DEFAULT_LAYER_POINT_IMAGE_ID } from '@/constants';
import type { ImageResource } from '@/types';

export const extractPointIconResources = (
  features: Feature[]
): ImageResource[] => {
  // NOTE: Point のフィーチャーのみ抽出し、customPointImage と customPointImageUrl をセット
  const pointIconResources = features
    .filter((feature) => feature?.geometry.type === 'Point')
    .map((feature) => ({
      id:
        feature.properties?.customPointImageId ?? DEFAULT_LAYER_POINT_IMAGE_ID,
      url: feature.properties?.customPointImageUrl as string | undefined,
    }))
    .filter(
      (item): item is ImageResource =>
        item.id !== undefined && item.url !== undefined
    );
  // NOTE: 重複排除
  const uniqueResources = Array.from(
    new Map(pointIconResources.map((item) => [item.id, item])).values()
  );

  return uniqueResources;
};
